import { smartAxios } from "../axios/Axios";
import { taxesEndpoints } from "./taxesEndpoints";

export const getJupidEmbedToken = async (): Promise<string> => {
  const response = await smartAxios.get(taxesEndpoints.embedToken);
  return response.data.token;
};
